
class CashRow extends React.Component {
  render () {
    const {label, value} = this.props
    return (<div className='row'>
      <div className='col-lg-12 box-divider'>
        <div className='form-group col-sm-12 label-section'>
          <label>{label}</label>
          <div>{value}</div>
        </div>
      </div>
    </div>)
  }
}

CashRow.propTypes = {
  label: React.PropTypes.string,
  value: React.PropTypes.string
}
export default CashRow



// WEBPACK FOOTER //
// ./app/pages/Reports/Shift/ShiftDetail/ShiftDetailModal/CashRow/CashRow.js